/** Help Center basics and beta feedback in the merchant Admin (docs/specs/beta.md, B-69). */
export const help = {
    title: "Help",
    description: "Short guides for the everyday work, and a direct line to the Sobthik team.",
    guides: "Guides",
    steps: "Steps",
    contactTitle: "Still stuck?",
    contactBody: "Send us a message with Feedback (top right). During the beta we answer within one working day.",
    articles: {
        start: {
            title: "Set up your business",
            summary: "Business details, your first branch and staff — about 10 minutes.",
            s1: "Settings → Business: add your logo, address and BIN (if you have one).",
            s2: "Settings → Locations: check your first branch; add more branches or a warehouse.",
            s3: "Settings → Staff: add each person with their mobile number, a first password and a role (Cashier, Branch Manager…). They choose their own password at first sign-in.",
            s4: "Settings → Security: turn on two-step sign-in for yourself.",
            s5: "Follow the checklist on the dashboard — every step can be skipped and done later.",
        },
        products: {
            title: "Add your products",
            summary: "One by one, from a spreadsheet, or start with sample products.",
            s1: "Catalog → Products → New product: name (English and Bengali), unit, price and cost.",
            s2: "Several sizes or colours? Add options; each combination becomes a variant with its own price and stock.",
            s3: "Many products: Catalog → Import → download the template, fill it in Excel, upload it.",
            s4: "Print barcode labels from the product or from a goods receipt.",
            s5: "Inventory → Adjust stock to enter what is on the shelves today.",
        },
        pos: {
            title: "Pair the POS and make your first sale",
            summary: "Install the POS app on the shop computer and sell — even without internet.",
            s1: "Install Sobthik POS on the computer at the counter.",
            s2: "Admin → POS → Devices → Pair a register: type the pairing code into the POS.",
            s3: "Open the shift with the cash in the drawer, scan or search products, take payment.",
            s4: "No internet? Keep selling. Bills are saved on the computer and sync by themselves later.",
            s5: "At closing: close the shift and count the cash; the Z report shows the day.",
        },
        orders: {
            title: "Online orders and couriers",
            summary: "Phone, Facebook and WhatsApp orders, delivered by your courier.",
            s1: "Settings → Couriers: connect your Pathao, Steadfast or RedX account.",
            s2: "Orders → New order: customer phone, address and products. Stock is held for the order.",
            s3: "Confirm the order, then Book courier: the consignment number is saved on the order.",
            s4: "The courier's updates (picked up, delivered, returned) appear on the order by themselves.",
            s5: "Cash on delivery: Payments → Courier payouts matches what the courier paid you.",
        },
        offline: {
            title: "When the internet is down",
            summary: "What keeps working, and what to check when it is back.",
            s1: "The POS sells, prints receipts and takes returns without internet, for days.",
            s2: "The status bar shows how many bills are waiting to sync.",
            s3: "Do not uninstall the POS or reset the computer while bills are waiting.",
            s4: "When the internet is back, bills sync within a minute; nothing is sent twice.",
            s5: "POS → Reviews lists any bill the server wants a manager to look at (for example, a stock difference).",
        },
        reports: {
            title: "Reports and closing the day",
            summary: "Sales, profit, stock and cash — and how to export them.",
            s1: "Dashboard: today's sales, profit and what needs action.",
            s2: "Reports: sales by product, branch, channel and payment method for any dates.",
            s3: "Export any report to Excel or PDF (Bengali works in both).",
            s4: "Accounts: the cash book per branch and every payment account's balance.",
            s5: "Settings → Data & account: download all your data any time.",
        },
    },
    feedback: {
        button: "Feedback",
        title: "Send feedback",
        description: "Tell us what went wrong, what would help, or ask a question. We read every message.",
        kind: "What is it?",
        kinds: { bug: "Something is wrong", idea: "An idea", question: "A question" },
        message: "Your message",
        messageHint: "What did you do, what happened, what did you expect? (at least 5 characters)",
        page: "Sent from {{page}}",
        send: "Send",
        sent: "Thank you — we got it.",
        mine: "Your feedback",
        empty: "You have not sent feedback yet.",
        answer: "Sobthik: {{answer}}",
        statuses: {
            new: "Received",
            triaged: "Looked at",
            planned: "Planned",
            fixed: "Fixed",
            wont_fix: "Not planned",
        },
    },
};
//# sourceMappingURL=help.js.map